
import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chart from "react-apexcharts";

const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});
  var oo=
  {
    chart: {
        type: 'bar',
        height: 250,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      tooltip: {
          theme: 'dark',
          y: {
            title: {
              formatter: function (w) {
                return `Base Stations`
              }
            }
          }
      },
      xaxis: {
        labels: {
          show: true,
          style: {
              colors: ['#FEFEFE'],
              fontSize: '12px',
              fontFamily: 'Montserrat',
              fontWeight: 300,
              cssClass: 'apexcharts-yaxis-label',
          },
        }
      },
      yaxis: {
         labels: {
          show: true,
          style: {
              colors: ['#FFFFFF', '#FFFFFF'],
              fontSize: '15px',
              fontFamily: 'Montserrat',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-label',
          },
         }
      },
      legend: {
        show: false,
      },
      colors: ['#ACDFEC', '#00AAD0'],
      };
    
      
export default function BarHorizontal(props) {
  const classes = useStyles();

  if(props.categories){
    console.log("cat")
    console.log(props.categories)
    oo.xaxis.categories = props.categories
  }

  return (
    <React.Fragment>
      <Typography component="h2" variant="h6">
          {props.title}
      </Typography>
      <div className="col percentage-chart">
          {props.data &&
          <Chart
            options={oo}
            height={250}
            series={[{ data: props.data }]}
            type="bar"/>
          }
      </div>
    </React.Fragment>
  );
}